import React from 'react';
import { bool, func, number, oneOfType, shape, string } from 'prop-types';
import { useStyle } from '@magento/venia-ui/lib/classify'; //'../../classify';

import defaultClasses from './tile.module.css';
import { useTile } from '@magento/peregrine/lib/talons/ProductOptions/useTile';

var getClassName = function getClassName(name, isSelected, hasFocus) {
  return "".concat(name).concat(isSelected ? '_selected' : '').concat(hasFocus ? '_focused' : '');
};

var Tile = function Tile(props) {
  var hasFocus = props.hasFocus,
      isSelected = props.isSelected,
      _props$item = props.item,
      label = _props$item.label,
      value_index = _props$item.value_index,
      swatch_data = _props$item.swatch_data,
      onClick = props.onClick;
  var talonProps = useTile({
    onClick: onClick,
    value_index: value_index
  });
  var handleClick = talonProps.handleClick;
  var classes = useStyle(defaultClasses, props.classes);
  var className = classes[getClassName('root', isSelected, hasFocus)];
  return React.createElement("button", {
    className: className,
    onClick: handleClick,
    title: label,
    type: "button",
    "aria-label": label
  }, React.createElement("span", null, label));
};

export default Tile;
Tile.propTypes = {
  hasFocus: bool,
  isSelected: bool,
  item: shape({
    label: string.isRequired,
    value_index: oneOfType([number, string]).isRequired
  }).isRequired,
  onClick: func.isRequired
};
Tile.defaultProps = {
  hasFocus: false,
  isSelected: false
};